import staticPathFilter from '../../../filters/static-path';
import { first } from 'lodash/fp';

export const LOGO_LIST = [
    'brand',
    'highschool',
    'economy',
    'medicine',
    'engineering',
    'medical-leadership',
];

export const DEFAULT_LOGO = first(LOGO_LIST);
const BASE_PATH = 'img/logos/img_';

export const getCurrentLogoPathsByName = name => {
    if (!LOGO_LIST.includes(name)) {
        throw new Error(`${ name } is not an available logo`);
    }

    return {
        positive: {
            big: staticPathFilter(`${ BASE_PATH }${ name }_pos.svg`),
            small: staticPathFilter(`${ BASE_PATH }${ name }_pos_small.svg`),
        },
        negative: {
            big: staticPathFilter(`${ BASE_PATH }${ name }_neg.svg`),
            small: staticPathFilter(`${ BASE_PATH }${ name }_neg_small.svg`),
        },
    };
};
